import React from 'react';
import { SOCIAL_LINKS } from './constants/constant';

function TopBar() {
    return (
        <div className="top-bar">
            <div className="social-icons">
                {SOCIAL_LINKS.map((link) => (
                    <a 
                        key={link.label}
                        href={link.href} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        aria-label={link.label}
                    >
                        <i className={link.icon}></i>
                    </a>
                ))}
            </div>
            <div className="logo">
            <img src="/assets/logo.svg" alt="Logo" />
            </div>
            <div className="right-images">
                <div className="border-right">
                    <img src="/assets/motorverse.svg" alt="Image 1"/>
                </div>
                <div>
                    <img src="/assets/animoca.svg" alt="Image 2"/>
                </div>
            </div>
        </div>
    );
}

export default TopBar;
